<template>
    <div v-if="user" >
        <GiftCodeCharge v-if="name === 'global' || name === 'proxygo'"/>
        <CryptoRecharge />
        <TransactionHistory />
    </div>
</template>
<script setup>
import GiftCodeCharge from './GiftCodeCharge.vue';
import CryptoRecharge from './CryptoRecharge.vue';
import TransactionHistory from './TransactionHistory.vue';
import { watchEffect } from 'vue';

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const name = process.env.VUE_APP_VUE_NAME;
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
watchEffect(() => {
    if (user.value) {
        // connectToWebSocket(user.value.user_name)
    }
})
</script>